import { render, staticRenderFns } from "./ReservationCapacityChange.vue?vue&type=template&id=c67dd7f8&"
import script from "./ReservationCapacityChange.vue?vue&type=script&lang=js&"
export * from "./ReservationCapacityChange.vue?vue&type=script&lang=js&"
import style0 from "./ReservationCapacityChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports